import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CloudService {
  constructor(private http: Http) {}

  private dataURItoBlob(dataURI: string): Blob {
    //
    // A data URI has the format "data:(MIME type);(encoding),(data)". Extract the MIME type from
    // between the first colon and semi-colon.
    //
    //    console.log(`Data URI to convert to blob: ${dataURI}`);
    const mimeTypeStartPos = dataURI.indexOf(':') + 1;
    const mimeTypeEndPos = dataURI.indexOf(';');
    const mimeType = dataURI.substring(mimeTypeStartPos, mimeTypeEndPos);
    //    console.log(`Start of mime type: ${mimeTypeStartPos}`);
    //    console.log(`End of mime type: ${mimeTypeEndPos}`);
    //    console.log(`Extracted mime type: ${mimeType}`);

    //
    // This algorithm for converting a data URI into a Blob for transmitting an image was taken from
    // https://stackoverflow.com/questions/33779791/how-to-upload-canvas-data-uri-to-amazon-s3-server
    //
    //    console.log(`Data URI split at comma: ${JSON.stringify(dataURI.split(','), null, 2)}`);
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: mimeType,
    });
  }

  uploadDataUri(url: string, data: string): Observable<Response> {
    //
    // Uploading files is usually done with the data in a File object. We have it in just a string.
    // A File is an extension of a Blob, so we can create a Blob with the data in it, specify the
    // MIME type, and the PUT should then treat the string just like a file.
    //
    const blob = this.dataURItoBlob(data);
    return this.http.put(url, blob).map((res: Response) => {
      //      console.log(`res: ${JSON.stringify(res, null, 2)}`);
      return res;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/cloud.service.ts